<template>
  <div class="modal-overlay" @click.self="close()">
    <div class="modal-content">
      <div class="title gept_main_bg text-white py-3 relative font-semibold text-lg">作答報告<a class="close-btn absolute top-0 right-0 text-lg" @click="close()"><i class="fas fa-times"></i></a></div>
      <div class="p-4">
        <div class="contain scroll-bar" v-if="selectItemIdx > -1">
          <div class="flex mb-3" v-if="itemData && isReadyShow">
            <div class="score-panel w-2/12 pr-2" v-if="type !== 'speaking' && itemData.result && itemData.result.ers && itemData.result.ers.Score">
              <div class="bg-white w-full h-full flex items-center justify-center">
                <div class="font-bold text-center">
                  <p class="mb-2">Score</p>
                  <p class="text-4xl font-black" v-if="itemData.result.ers">{{ itemData.result.ers.Score }}</p>
                </div>
              </div>
            </div>
            <div class="flex-1">
              <div class="flex rounded-lg overflow-hidden mb-1">
                <div class="p-5 gept_main_bg6 text-white flex items-center">Q{{ selectChildIdx + 1 }}</div>
                <div class="flex-1 bg-white flex items-center p-1">
                  <div class="p-2 cursor-pointer" @click.prevent="setAudio(itemData.result.question.AudioUrl)" v-if="itemData.result.question && itemData.result.question.AudioUrl">
                    <img class="block h-auto mx-auto object-contain w-10/12" src="@/assets/image/gept/m_play.png" alt="">
                  </div>
                  <div>
                    <div v-if="itemData.result.question.ImageUrl">
                      <img :src="itemData.result.question.ImageUrl" alt="">
                    </div>

                    <p class="text-lg font-semibold" v-html="itemData.result.question.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
                  </div>
                </div>
              </div>
              <div class="teacher_answer rounded-lg mb-1 flex overflow-hidden">
                <div class="p-5 gept_main_bg5 text-white flex items-center">A{{ selectChildIdx + 1 }}</div>
                <div class="flex-1 bg-white p-1 flex items-center">
                  <div class="flex items-center mb-2">
                    <div class="p-2 cursor-pointer" v-if="itemData.user_answer && itemData.user_answer.audio" @click.prevent="setAudio(itemData.user_answer.audio)">
                      <img class="block h-auto mx-auto object-contain w-10/12" src="@/assets/image/gept/voice_play.png" alt="">
                    </div>

                    <p class="text-lg font-semibold" v-if="hasScoredAnswerText"><span v-for="(child, idx) in spiltWords(scoredAnswerText)" :key="idx" :class="{ 'good-text': checkScore(answerWordScores, scoredAnswerText, child) > 80, 'acceptable-text': checkScore(answerWordScores, scoredAnswerText, child) > 60 && checkScore(answerWordScores, scoredAnswerText, child) < 81, 'strengthened-text': checkScore(answerWordScores, scoredAnswerText, child) < 61 }">{{ child }}</span></p>
                    <p class="text-lg font-semibold" v-else-if="answerText" v-html="return_user_text(answerText)"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white p-2 px-3" v-if="resultDisplayText && isReadyShow">
            <div v-html="return_user_text(resultDisplayText)" class="text-left"></div>
          </div>
          <div v-else-if="!isReadyShow">
            <div class="flex justify-center w-full">
              <LottieAnimation class="w-4/12 xl:w-2/12"
              ref="anim"
              :animationData="require('@/assets/image/gept/mark_loading.json')"
              :loop="true"
              :auto-play="true"
              :speed="1" />
            </div>
            <div class="flex justify-center w-full">
              <div class="w-10/12 h-2 bg-white mt-6 rounded-full relative overflow-hidden">
                <div class="absolute h-2 gept_main_bg progress"></div>
              </div>
            </div>

            <p class="text-center mt-6 gept_main_color font-bold text-lg">正在批改...</p>
          </div>
          <!-- <div v-else class="bg-white p-3 px-4 text-left font-semibold">
            目前沒有批改文字結果，請稍後再試或確認此題是否已有批改回傳。
          </div> -->


        </div>
      </div>
      <!-- <slot></slot>
      <button class="close-btn" @click="close">關閉</button> -->
    </div>
  </div>
</template>
<script>
import LottieAnimation from 'lottie-web-vue'
export default {
  name: 'ReportModal',

  data () {
    return {
      isReadyShow: false,
      sound_effect: null
    }
  },

  props: {
    type: {
      type: String
    },

    itemName: {
      type: String
    },

    selectItemIdx: {
      type: Number
    },

    selectChildIdx: {
      type: Number
    },

    showfirstModal: {
      type: Boolean,
      default: false
    },

    itemData: {
      type: Object
    }
  },

  components: {
    LottieAnimation
  },
  computed: {
    answerText () {
      if (this.type === 'speaking') {
        return this.scoredAnswerText
      }

      return this.scoredAnswerText ||
        this.itemData?.result?.result?.text ||
        this.itemData?.result?.result?.Text ||
        this.itemData?.result?.result?.stt ||
        this.itemData?.result?.result?.sText ||
        this.itemData?.result?.text ||
        this.itemData?.result?.Text ||
        this.itemData?.result?.user_text ||
        this.itemData?.user_answer?.text ||
        ''
    },
    scoredAnswerText () {
      return this.itemData?.result?.ers?.Text || ''
    },
    answerWordScores () {
      return this.itemData?.result?.ers?.WordScores || []
    },
    hasScoredAnswerText () {
      return Boolean(this.scoredAnswerText && this.answerWordScores.length)
    },
    resultText () {
      const result = this.itemData?.result?.result
      if (typeof result === 'string') return result
      if (result && typeof result.result === 'string') return result.result
      return ''
    },
    newResult () {
      const str = this.resultText

      if (typeof str !== 'string') return null

      try {
        return JSON.parse(str)
      } catch (e) {
        return null
      }
    },
    resultDisplayText () {
      return this.newResult?.result || (!this.newResult ? this.resultText : '')
    }
  },
  mounted () {
    this.setTimeoutFun()
  },
  methods: {
    cleanTimeOut () {
      let self = this
      clearTimeout(self.timeOutProcessId)
    },
    setTimeoutFun () {
      let self = this
      self.timeOutProcessId = setTimeout(() => {
        self.isReadyShow = true
      }, 1000 * 1)
    },

    close () {
      let self = this
      self.$emit('closeModal', false)
      // self.correctionResult = null
    },

    spiltWords (text) {
      let words = text.split(/(\s+|[,.!?])/).filter(Boolean)
      return words
    },

    checkScore (WordScores, text, child) {
      let parts = text.split(/(\s+|[,.!?])/).filter(Boolean);

      let wordsOnly = parts.filter(part => !part.match(/(\s+|[,.!?])/));

      let index = wordsOnly.indexOf(child)

      return Number(WordScores[index])
    },

    setAudio (url) {
      let self = this
      if (url) {
        if (self.sound_effect) {
          const myName1 = () => {
            return new Promise(async(resolve) => {
              self.audio_stop()
              resolve('ok')
            })
          }

          Promise.race([myName1()])
          .then(() => {
            self.sound_effect = new Audio(url)

            self.audio_play()
          })
        } else {
          self.sound_effect = new Audio(url)

          self.audio_play()
        }
      }
    },

    audio_play () {
      let self = this

      self.sound_effect ? self.sound_effect.play() : null

      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()
      })
    },

    audio_stop () {
      let self = this

      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
    },

    return_user_text (text) {
      return text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
    }
  }
}
</script>

<style lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #E3ECF1;
  border-radius: 5px;
  max-width: 500px;
  width: 100%;
  min-width: 70vw;
  height: 90vh;
  max-height: 90vh;
  max-width: 70vw;
  overflow-y: scroll;
  overflow-x: hidden;
}
.score-panel {
  flex: 0 0 120px;
  max-width: 120px;
  min-width: 120px;
  width: 120px;
}

.score-panel > div {
  padding: 0.75rem 0.5rem;
}

.score-panel .text-4xl {
  display: block;
  max-width: 100%;
  line-height: 1;
  margin-bottom: 0;
  white-space: nowrap;
  font-size: clamp(2rem, 4vw, 3.5rem);
  letter-spacing: 0;
}

@media (max-width: 768px) {
  .contain > .flex.mb-3 {
    flex-direction: column;
  }

  .score-panel {
    flex: 0 0 auto;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    padding-right: 0 !important;
    margin-bottom: 0.5rem;
  }

  .score-panel > div {
    padding: 0.75rem 1rem;
  }

  .score-panel > div > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left;
  }

  .score-panel .mb-2 {
    margin-bottom: 0;
  }

  .score-panel .text-4xl {
    font-size: 2rem;
  }
}

.close-btn {
  margin-top: 8px;
  padding: 5px 10px;
  background-color: transparent;
  color: white;
  cursor: pointer;
}

  .good-bg {
    background-color: rgba(0, 149, 86, 1);
  }
  .acceptable-bg {
    background-color: rgba(255, 193, 7, 1);
  }
  .strengthened-bg {
    background-color: rgba(243, 0, 0, 1);
  }
  .good-text {
    color: rgba(0, 149, 86, 1);
  }
  .acceptable-text {
    color: rgba(255, 193, 7, 1);
  }
  .strengthened-text {
    color: rgba(243, 0, 0, 1);
  }
  .vm-btn-close {
    outline: none !important;
  }
  .modal-outer {
    max-width: 80vw;
    // max-width: 1500px;
    .vm-titlebar {
      color: white !important;
      background: #0F455C;
      text-align: center;
    }
    .vm-content {
      background: #E3ECF1;
      height: 80vh;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .teacher_answer {
      display: none;
    }
  }
  .progress {
    // background-color: #e4c465;
    animation: progressBar 3s ease-in-out infinite;
    animation-fill-mode: both;
}
  @keyframes progressBar {
    0% { width: 0; }
    100% { width: 100%; }
  }
</style>
